import type { ApolloCache, Resolvers } from '@apollo/client';
import { UserDocument } from 'generated/graphql';
import gql from 'graphql-tag';

export const clientSchema = gql`
  type User {
    email: String!
    alias: String!
    groups: [String!]!
  }

  extend type Query {
    user: User
  }
`;

type ResolverFn = (
  // biome-ignore lint/suspicious/noExplicitAny: legacy code
  parent: any,
  // biome-ignore lint/suspicious/noExplicitAny: legacy code
  args: any,
  {
    cache,
  }: {
    // biome-ignore lint/suspicious/noExplicitAny: legacy code
    cache: ApolloCache<any>;
  },
  // biome-ignore lint/suspicious/noExplicitAny: legacy code
) => any;
type ResolverMap = {
  [field: string]: ResolverFn;
};

interface AppResolvers extends Resolvers {
  Query: ResolverMap;
}

// This is a client-side resolver map that fulfills queries and mutations marked with the @client directive.
// See https://www.apollographql.com/docs/react/local-state/client-side-schema/
// and https://www.apollographql.com/docs/react/local-state/managing-state-with-field-policies/
export const resolvers: AppResolvers = {
  Query: {
    user: (_root, _args, context) =>
      context.cache.readQuery({
        query: UserDocument,
      }),
  },
};
